/**
 * Indicates where to redirect after authentication.
 */
export const REDIRECT_QUERY_KEY = 'redirectTo';

/**
 * Param to override the pinned store.
 */
export const STORE_ID_QUERY_KEY = 'storeid';

/**
 * Whether the retailer is previewing their age gate changes from Business Admin.
 */
export const AGE_GATE_QUERY_KEY = 'age-gate';

/**
 * Whether the retailer is previewing their sign-in prompt changes from
 * Business Admin. Force-shows the prompt regardless of cookie-dismissed state.
 */
export const SIGN_IN_PROMPT_QUERY_KEY = 'sign-in-prompt';

/**
 * Whether the retailer is previewing their theme changes from Business Admin.
 */
export const DRAFT_QUERY_KEY = 'draft';

/**
 * Indicates the current product search term.
 */
export const SEARCH_TERM_QUERY_KEY = 'searchText';

/**
 * How many pages of product results are on screen, written with
 * `history.replaceState` as pages load so a reload or back navigation can
 * hydrate them up front.
 */
export const CURRENT_PAGE_QUERY_KEY = 'currentPage';

/**
 * Indicates the current sort order of product search results.
 */
export const SORT_ORDER_QUERY_KEY = 'sort';

/**
 * Indicates whether the store switcher should be opened.
 */
export const SELECT_STORE_QUERY_KEY = 'select-store';

/**
 * Indicates the preferred fulfillment method (delivery or pickup).
 * When used with select-store=true, opens store switcher with fulfillment pre-selected.
 * When used alone, attempts to set fulfillment at current store or opens store switcher if not available.
 */
export const RESERVATION_MODE_QUERY_KEY = 'reservation-mode';

/**
 * UTM source parameter for Mixpanel attribution tracking.
 */
export const UTM_SOURCE_QUERY_KEY = 'utm_source';

/**
 * UTM medium parameter for Mixpanel attribution tracking.
 */
export const UTM_MEDIUM_QUERY_KEY = 'utm_medium';

/**
 * UTM campaign parameter for Mixpanel attribution tracking.
 */
export const UTM_CAMPAIGN_QUERY_KEY = 'utm_campaign';

/**
 * Promo code parameter for cart discounts.
 */
export const PROMO_CODE_QUERY_KEY = 'promo_code';
